import React, { useState } from "react";
import { useUserRole } from "../../../context/UserRoleContext";
import DashboardLayout from "../../../components/common/DashboardLayout";
import ProfileSettings from "../components/settings/ProfileSettings";
import NotificationSettings from "../components/settings/NotificationSettings";
import SupportSettings from "../components/settings/SupportSettings";
import PrivacySettings from "../components/settings/PrivacySettings";

const Settings = () => {
  const { userData, loading } = useUserRole();
  const [activeTab, setActiveTab] = useState("profile");

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  const tabs = [
    { id: "profile", label: "Profile", icon: "👤" },
    { id: "notifications", label: "Notifications", icon: "🔔" },
    { id: "support", label: "Support", icon: "💬" },
    { id: "privacy", label: "Privacy", icon: "🛡️" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileSettings />;
      case "notifications":
        return <NotificationSettings />;
      case "support":
        return <SupportSettings />;
      case "privacy":
        return <PrivacySettings />;
      default:
        return <ProfileSettings />;
    }
  };

  return (
    <DashboardLayout>
      <div className="bar-owner-dashboard">
        {/* Tab Selector */}
        <div className="tab-selector">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </DashboardLayout>
  );
};

export default Settings;
